module.exports = __webpack_public_path__ + "img/southcampusdeck-h-474x356.7055d41b.jpg";